import { fetcher } from '../utils'
import { ChatDepartment, ComponentTagVO } from '@repo/types'

export default async (
  onlyUserTags: boolean,
  department?: ChatDepartment,
  filter?: string
): Promise<ComponentTagVO[]> => {
  let path = `/api/tag/list?onlyUserTags=${onlyUserTags}`

  if (department) {
    path = path + `&department=${department}`
  }

  if (filter) {
    path = path + `&filter=${filter}`
  }

  return fetcher(path, 'GET', undefined)
}
